/**
 * Controls help — the card `?` opens.
 *
 * Self-contained on purpose: it builds its DOM and injects its own stylesheet
 * on first use, so the SAME module serves index.html and gym.html without
 * either page carrying markup for it. InputManager owns the `?` / Esc
 * bindings; nothing else needs to know this exists.
 */

const ROWS = [
  ['WASD', 'Move'],
  ['Space', 'Jump'],
  ['Shift (hold)', 'Sprint'],
  ['LMB / C', 'Attack'],
  ['Q · E · R', 'Skills · Ultimate'],
  ['F / RMB', 'Dash'],
  ['?', 'Toggle this help'],
  ['Esc', 'Close · free the cursor'],
];

const CSS = `
#help-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(4, 5, 12, 0.55);
}
#help-overlay[hidden] { display: none; }
#help-overlay .help-card {
  min-width: 280px;
  padding: 18px 22px;
  border-radius: 14px;
  background: var(--hud-bg, rgba(11, 11, 24, 0.92));
  border: 1px solid var(--hud-line, rgba(255, 255, 255, 0.14));
  backdrop-filter: blur(8px);
  color: var(--hud-fg, #e8e9f4);
  animation: annIn 180ms ease-out;
}
#help-overlay .help-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 12px;
}
#help-overlay .help-row {
  display: flex;
  justify-content: space-between;
  gap: 26px;
  font-size: 12px;
  line-height: 2;
}
#help-overlay .help-row .key {
  font-weight: 700;
  letter-spacing: 0.04em;
}
#help-overlay .help-row .what {
  color: var(--hud-dim, rgba(232, 233, 244, 0.6));
}
`;

let _el = null;

function ensure() {
  if (_el) return _el;
  const style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  _el = document.createElement('div');
  _el.id = 'help-overlay';
  _el.hidden = true;
  _el.innerHTML = `
    <div class="help-card">
      <div class="help-title">Controls</div>
      ${ROWS.map(([key, what]) => `<div class="help-row"><span class="key">${key}</span><span class="what">${what}</span></div>`).join('')}
    </div>
  `;
  // Anywhere-click closes it. The pointer cannot be locked while it is open
  // (opening needs a free cursor for `?`), so the click swings nothing.
  _el.addEventListener('mousedown', (e) => e.stopPropagation());
  _el.addEventListener('click', () => hideHelpOverlay());
  document.body.appendChild(_el);
  return _el;
}

export function toggleHelpOverlay() {
  const el = ensure();
  el.hidden = !el.hidden;
}

export function hideHelpOverlay() {
  if (_el) _el.hidden = true;
}
